import { useQuery } from '@tanstack/react-query'
import { notificationsApi } from '../services/api'
import { useAuth } from './useAuth'

export const useNotifications = () => {
    const { isAuthenticated } = useAuth()

    const { data: unreadCountData, refetch: refetchUnreadCount } = useQuery({
        queryKey: ['notifications', 'unread-count'],
        queryFn: () => notificationsApi.getUnreadCount(),
        select: (response) => response.data.data.count,
        refetchInterval: 30000, // Refetch every 30 seconds
        enabled: isAuthenticated, // Only run when user is authenticated
    })

    const { data: notificationsData, refetch: refetchNotifications } = useQuery({
        queryKey: ['notifications'],
        queryFn: () => notificationsApi.getNotifications({ page: 1, limit: 50 }),
        select: (response) => response.data.data,
        enabled: false, // Only fetch when explicitly requested
    })

    const unreadCount = unreadCountData || 0

    return {
        unreadCount,
        notifications: notificationsData || [],
        refetchUnreadCount,
        refetchNotifications,
    }
} 